



























































import { Component, Vue } from 'vue-property-decorator';
import QueueLagService from '@/domain/queue-lag/queue-lag.service';
import MandalaLagDisplay from './mandala-lag-display.component.vue';
import QueueLag from '@/domain/queue-lag/queue-lag.entity';

@Component({
  components: { MandalaLagDisplay },
})
export default class MandalaLagsDisplayComponent extends Vue {
  vstsLags: QueueLag[] = [];

  workitemsLag: QueueLag[] = [];

  tasksLags: QueueLag[] = [];

  get vstsLagsSum(): number {
    return this.sumQueueLags(this.vstsLags);
  }

  get workitemLagsSum(): number {
    return this.sumQueueLags(this.workitemsLag);
  }

  get taskLagsSum(): number {
    return this.sumQueueLags(this.tasksLags);
  }

  get hasAnyQueueWithLag(): boolean {
    return this.vstsLags.some((it: QueueLag) => it.hasSmallLagOrAbove())
      || this.workitemsLag.some((it: QueueLag) => it.hasSmallLagOrAbove())
      || this.tasksLags.some((it: QueueLag) => it.hasSmallLagOrAbove());
  }

  get laggedQueues(): QueueLag[] {
    const queues = [...this.vstsLags, ...this.workitemsLag, ...this.tasksLags];
    return queues.filter((it: QueueLag) => it.getTotalLag() > 0);
  }

  get estimatedVstsTimeToWait(): string {
    const waitSeconds = ((this.vstsLagsSum + this.workitemLagsSum) * 4) + 4;
    return this.formatTimeToWait(waitSeconds);
  }

  get estimatedMandalaTimeToWait(): string {
    const waitSeconds = (this.workitemLagsSum * 4) + 4;
    return this.formatTimeToWait(waitSeconds);
  }

  private formatTimeToWait(seconds: number): string {
    if (seconds < 60) {
      return `${seconds}s`;
    }
    if (seconds < 3600) {
      return `${Math.ceil(seconds / 60)}m`;
    }
    return `${(seconds / 3600).toFixed(2)}h`;
  }

  private sumQueueLags(lags: QueueLag[]): number {
    return lags.reduce((acc, topic) => {
      const topicLag = topic.partitions.reduce((sum, partition) => sum + partition.lag, 0);
      return acc + topicLag;
    }, 0);
  }

  private loadVstsLag() {
    QueueLagService.getVstsLag().then((vstsLags: QueueLag[]) => {
      this.vstsLags = vstsLags;
    });
  }

  private loadWorkitemLag() {
    QueueLagService.getWorkitemLag().then((workitemsLag: QueueLag[]) => {
      this.workitemsLag = workitemsLag;
    });
  }

  private loadTasksLag() {
    QueueLagService.getTaskLag().then((tasksLags: QueueLag[]) => {
      this.tasksLags = tasksLags;
    });
  }

  private loadAllLags() {
    this.loadVstsLag();
    this.loadWorkitemLag();
    this.loadTasksLag();
  }

  created() {
    this.loadAllLags();
    setInterval(this.loadAllLags, 30000);
  }
}
